module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACJSURBVHgB7dGxDcJADAXQ/y8u6LgK2oyAhKhZgYzABKzCSvQUtwG0dKYlYCOQEqVIlERp85o7f1tyYS7XuxvgOSYws6PQygKZREyQlZYw68XqE1fbg5MnDKfPx7WoCqnj8ElucsFAHuyO2SjsavyuaOCmmYXX+6yatG1e0LnCc4L7RqJYIP7fFl+PTSO7RZBv+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filter.png
// module id = 8TSM
// module chunks = 1